import { ActivePromoForCruise } from "src/utils/promos";
import { CruiseTemplateSuiteFragment } from "types/graphql-types";

const isLowerSuite = (suite: CruiseTemplateSuiteFragment) => {
  return (suite?.category?.order || 0) > 25;
};

export const fakeSuiteUpgradePromo = (
  suite: CruiseTemplateSuiteFragment,
  activePromos: ActivePromoForCruise[]
) => {
  const suiteUpgradesPromo = activePromos.find(
    (p) => p.code == "CATEGORY_UPGRADE"
  );
  const isTargetSuite = isLowerSuite(suite);

  if (suiteUpgradesPromo && isTargetSuite) {
    return suiteUpgradesPromo;
  }

  return undefined;
};
